import React from 'react'
import App from './index'
import './style/theme/qxtj.css'
import { createRoot } from 'react-dom/client'

window.addEventListener('load', () => {
  createRoot(document.getElementById('root'))
    .render(<App/>)
})
